import * as React from 'react';

import type { Graph, Thing, WithContext } from 'schema-dts';

import { clearEmptyFields, stringifyJsonLd } from 'bundles/seo/utils/utils';

type Props = {
  graph: Graph | WithContext<Thing>;
};

const GoogleMarkup = ({ graph }: Props) => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
        <script type="application/ld+json">
          ${stringifyJsonLd(clearEmptyFields(graph))}
        </script>
      `,
      }}
    />
  );
};

export default GoogleMarkup;
